import { useQuery } from "@tanstack/vue-query";
import { toValue, type Ref } from "vue";

import { useServices } from "@/configuration/plugins/app/app-provider.configuration";
import { SitesQueryKeys } from "@/data/api/kili/sites/sites-query-keys";
import { V4HSiteId } from "@/data/common/ids";

export function useV4hSiteSectionsForestQuery(siteId: Ref<V4HSiteId>) {
  const v4bClientSdk = useServices().v4b.clientSdk;

  return useQuery({
    queryKey: SitesQueryKeys.sectionsForest(siteId),
    queryFn: () => v4bClientSdk.siteSection.findForest(toValue(siteId)),
  });
}
